import { operatorApiFetch } from './apiService';

export const billingService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('billings/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  getIds: async (params) => {
    const response = await operatorApiFetch('billings/get_ids', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  get: async (billingId) =>
    operatorApiFetch(`billings/${billingId}`, { method: 'GET' }).then(r => r.json()),

  updateStatus: async (billingId, status) =>
    operatorApiFetch(`billings/${billingId}/update_status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    }).then(r => r.json()),

  addItem: async (billingId, data) =>
    operatorApiFetch(`billings/${billingId}/add_item`, {
      method: 'POST',
      body: JSON.stringify({ billing_item: data }),
    }).then(r => r.json()),
};
